import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TooltipHelp = ({ placement, toolTipText, id }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <span>
      <FontAwesomeIcon
        className="text-primary ms-2"
        size="xs"
        icon="circle-question"
        id={"Tooltip-" + id}
      />
      <Tooltip
        placement={placement}
        isOpen={tooltipOpen}
        target={"Tooltip-" + id}
        toggle={toggle}
        fade={false}
      >
        {toolTipText}
      </Tooltip>
    </span>
  );
};

export default TooltipHelp;
